import { render, staticRenderFns } from "./SoccerhowCustomerSupport.vue?vue&type=template&id=45b8c2ad&scoped=true&"
import script from "./SoccerhowCustomerSupport.vue?vue&type=script&lang=js&"
export * from "./SoccerhowCustomerSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8c2ad",
  null
  
)

export default component.exports